import { HistogramConfigurationProviderProps } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { HistogramPanelData } from 'features/drilldown/components/histogram/DrilldownHistogram'

const LATEST_DATA_SCHEMA_VERSION = 3

export const DEFAULT_ASSET_HISTOGRAM_PANEL_DATA: HistogramPanelData = {
  panelDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  title: 'Asset Indication Counts',
  isPinned: true,
  selectedBarIds: [],
  groupingColumn: 'unit.id',
  aggregationColumn: 'indication.id',
  aggregationOperation: 'count',
}

export const ASSET_HISTOGRAM_CONFIG_PROPS: HistogramConfigurationProviderProps =
  {
    defaultPanelData: DEFAULT_ASSET_HISTOGRAM_PANEL_DATA,
    latestDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  }
